import React from 'react';
import TrendingUp from 'lucide-react/dist/esm/icons/trending-up.js';
import CheckCircle from 'lucide-react/dist/esm/icons/check-circle.js';
import { useTranslations } from '../../../contexts/TranslationContext';
import { useDrawsPage } from './DrawsPageContext';
import { useDrawsCopy } from './useDrawsCopy';

export default function DrawsCta() {
  const { t } = useTranslations();
  const { activeTab } = useDrawsPage();
  const { howItWorks } = useDrawsCopy();

  if (activeTab !== 'upcoming') return null;

  return (
    <div className="bg-gradient-to-br from-cyan-50 to-blue-50 dark:from-cyan-900/20 dark:to-blue-900/20 rounded-2xl p-8 border border-cyan-100 dark:border-cyan-800">
      <div className="flex items-start gap-4">
        <div className="bg-gradient-to-br from-cyan-500 to-blue-500 p-3 rounded-xl flex-shrink-0">
          <TrendingUp className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
            {howItWorks('title')}
          </h3>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            {howItWorks('body')}
          </p>
          <ul className="space-y-2 text-gray-700 dark:text-gray-300">
            <li className="flex items-start gap-2">
              <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
              <span>{howItWorks('bullet1')}</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
              <span>{howItWorks('bullet2')}</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
              <span>{howItWorks('bullet3')}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
